import { useCallback, useSyncExternalStore } from "react";
const listeners = new Set();
const subscribe = (listener) => {
    listeners.add(listener);
    window.addEventListener("storage", listener);
    return () => {
        listeners.delete(listener);
        window.removeEventListener("storage", listener);
    };
};
const useLocalStorage = (key) => {
    const value = useSyncExternalStore(subscribe, () => localStorage.getItem(key));
    const setValue = useCallback((next) => {
        if (next === null) {
            localStorage.removeItem(key);
        }
        else {
            localStorage.setItem(key, next);
        }
        listeners.forEach((listener) => listener());
    }, [key]);
    return [value, setValue];
};
export default useLocalStorage;
//# sourceMappingURL=useLocalStorage.js.map